import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91c74052"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Para una mayor seguridad, deberá insertar un código (enviado por uno de los siguientes métodos) para iniciar sesión. ", -1 /* HOISTED */))
const _hoisted_2 = ["id", "checked"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1 /* HOISTED */))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "d-block fw-semibold text-start" }
const _hoisted_8 = { class: "text-dark fw-bold d-block fs-3" }
const _hoisted_9 = { class: "text-muted fw-semibold fs-6" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "card p-fluid" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "code" }, "Introduzca el código de verificación enviado.", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      header: "Método de autenticación",
      visible: $setup.showModalAuthType,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (($setup.showModalAuthType) = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '30vw' },
      modal: true,
      maximizable: true,
      closable: $props.canClose
    }, {
      footer: _withCtx(() => [
        ($setup.selectedFactorAuthType != '')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              id: "setDobleFactorUserCode",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showModalEnterCode($setup.selectedFactorAuthType))),
              label: "Continuar",
              class: "p-button"
            }))
          : _createCommentVNode("v-if", true),
        ($props.canClose)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              id: "cerrar",
              label: "Cerrar",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('update:showModalAuthTypeChild', false)), ["stop"])),
              icon: "pi pi-times",
              class: "p-button-secondary"
            }))
          : _createCommentVNode("v-if", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_1,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getDobleFactorAuthOptions, (doblefactorauth, index) => {
            return (_openBlock(), _createElementBlock("div", { key: doblefactorauth }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                class: "btn-check",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.picked_two_factor) = $event)),
                name: "auth_option",
                value: "apple",
                id: doblefactorauth,
                checked: $setup.checkedValue == index
              }, null, 8 /* PROPS */, _hoisted_2), [
                [_vModelRadio, $setup.picked_two_factor]
              ]),
              _createElementVNode("label", {
                class: "btn btn-outline btn-outline-dashed btn-active-light-primary p-7 d-flex align-items-center mb-5",
                onClick: ($event: any) => ($setup.chooseTwoFactorType(index, $setup.getDobleFactorAuthOptions[index]))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass($setup.getAutenticatorIcon($setup.getDobleFactorAuthOptions[index]))
                }, _hoisted_6, 2 /* CLASS */),
                _createElementVNode("span", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString($setup.getAutenticatorTitle($setup.getDobleFactorAuthOptions[index])), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_9, _toDisplayString($setup.getAutenticatorDescription($setup.getDobleFactorAuthOptions[index])), 1 /* TEXT */)
                ])
              ], 8 /* PROPS */, _hoisted_3)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible", "closable"]),
    _createVNode(_component_Dialog, {
      header: "Confirmar código doble autenticación",
      visible: $setup.showEnterCode,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (($setup.showEnterCode) = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '30vw' },
      modal: true,
      maximizable: true,
      closable: $props.canClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          id: "checkCode",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.confirmCode())),
          label: "Confirmar",
          class: "p-button"
        }),
        ($props.canClose)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              id: "cerrar",
              label: "Cerrar",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => {$setup.hideModalEnterCode($setup.selectedFactorAuthType);}, ["stop"])),
              icon: "pi pi-times",
              class: "p-button-secondary"
            }))
          : _createCommentVNode("v-if", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_InputText, {
                id: "code",
                type: "text",
                modelValue: $setup.inputCode,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.inputCode) = $event))
              }, null, 8 /* PROPS */, ["modelValue"])
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible", "closable"])
  ], 64 /* STABLE_FRAGMENT */))
}